import { ISyncModel, SyncModel } from '@common/models/SyncModel';
import {
  ConsentModel,
  IConsentModel,
  IModel,
  IPhotoModel,
  IVisitConsentClientModel,
  Model,
  PhotoModel,
  VisitConsentClientModel,
} from '.';

export interface IVisitConsentModel extends ISyncModel {
  visitConsentId: number;
  visitId: number;
  consentId: number;
  clientSignaturePhotoId: number | undefined;
  consent: IConsentModel;
  clientSignaturePhoto: IPhotoModel;
  visitConsentClient: IVisitConsentClientModel | undefined;
}

export class VisitConsentModel
    extends SyncModel
  implements Record<keyof IVisitConsentModel, any>
{
  visitConsentId: number;
  visitId: number;
  consentId: number;
  clientSignaturePhotoId: number | undefined;
  consent: ConsentModel;
  clientSignaturePhoto: PhotoModel | undefined;
  visitConsentClient: VisitConsentClientModel | undefined;

  constructor(params: IVisitConsentModel) {
    super(params);
    this.visitConsentId = params.visitConsentId;
    this.visitId = params.visitId;
    this.consentId = params.consentId;
    this.clientSignaturePhotoId = params.clientSignaturePhotoId;
    this.consent = new ConsentModel(params.consent);
    this.clientSignaturePhoto = params.clientSignaturePhoto
      ? new PhotoModel(params.clientSignaturePhoto)
      : undefined;
    this.visitConsentClient = params.visitConsentClient
      ? new VisitConsentClientModel(params.visitConsentClient)
      : undefined;
  }
}
